import { alias, createModelSchema, custom, deserialize, serialize, SKIP } from "serializr";
import { Cloneable } from "@/common/Cloneable";
import { RewardModel } from "@/modules/redactor/models/reward/RewardModel";

export class LevelTrackReward extends Cloneable {

    constructor() {
        super();

        this._rewardIndex = 0;
        this._reward = null;
    }

    get rewardIndex() {
        return this._rewardIndex;
    }

    set rewardIndex(value) {
        this._rewardIndex = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {
        if (!Number.isInteger(this.rewardIndex) || this.rewardIndex < 0) {
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return (this.rewardIndex === undefined || this.rewardIndex === null) && (!this.reward || this.reward.empty());
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelTrackReward());
        } else if (target instanceof LevelTrackReward) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(LevelTrackReward, v) : SKIP;
        }, (v) => {
            return deserialize(LevelTrackReward, v);
        });
    }
}

createModelSchema(LevelTrackReward, {
    _rewardIndex: alias("index", toNumber()),
    _reward: alias("reward", RewardModel.schema()),
});

function toNumber() {
    return custom(
        (value) => Number(value),
        (value) => Number(value),
    );
}
